var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppPageContainer',{attrs:{"showNav":true,"clean":true,"background":'calendar'}},[_c('div',{staticClass:"affiliate-dashboard"},[_c('div',{staticClass:"affiliate-dashboard--header"},[_c('h1',[_vm._v("Affiliate Dashboard")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }